import React, { useEffect, useState } from 'react';
import { API_BASE } from '../config/api';

const GestionSalas = () => {
  const [salas, setSalas] = useState([]);
  const [colegios, setColegios] = useState([]);
  const [formulario, setFormulario] = useState({
    colegio_id: '',
    nombre: '',
    tipo: 'Informática'
  });

  // ====== Modal Detalle Sala ======
  const [modalAbierto, setModalAbierto] = useState(false);
  const [salaActual, setSalaActual] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [guardandoDetalle, setGuardandoDetalle] = useState(false);

  const [detalle, setDetalle] = useState({
    // Impresora
    tiene_impresora: 0,
    impresora_marca: '',
    impresora_modelo: '',
    impresora_tiene_cable_usb: 0,

    // Proyector (SIN control)
    tiene_proyector: 0,
    proyector_marca: '',
    proyector_modelo: '',
    proyector_cable_tipo: 'NINGUNO', // ENUM('VGA','HDMI','NINGUNO')

    // Televisor (CON control)
    tiene_televisor: 0,
    televisor_marca: '',
    televisor_pulgadas: '',
    televisor_cable_tipo: 'NINGUNO', // ENUM('VGA','HDMI','NINGUNO')
    televisor_tiene_control: 0,

    observacion: '',
    fecha_verificacion: '' // datetime-local
  });

  useEffect(() => {
    const cargar = async () => {
      try {
        // 1) colegios
        const resColegios = await fetch(`${API_BASE}/api/colegios`);
        const dataColegios = resColegios.ok ? await resColegios.json() : [];
        const listaColegios = Array.isArray(dataColegios) ? dataColegios : [];
        setColegios(listaColegios);

        // 2) salas de todos los colegios
        const allSalas = [];

        await Promise.all(
          listaColegios.map(async (colegio) => {
            try {
              const resSalas = await fetch(`${API_BASE}/api/colegios/${colegio.id}/salas`);
              const dataSalas = resSalas.ok ? await resSalas.json() : [];
              const listaSalas = Array.isArray(dataSalas) ? dataSalas : [];

              listaSalas.forEach((s) => allSalas.push({ ...s, colegio: colegio.nombre }));
            } catch (e) {
              console.error('Error cargando salas del colegio:', colegio?.id, e);
            }
          })
        );

        setSalas(allSalas);
      } catch (e) {
        console.error('Error cargando colegios/salas:', e);
        setColegios([]);
        setSalas([]);
      }
    };

    cargar();
  }, []);

  const manejarCambio = (e) => {
    const { name, value } = e.target;
    setFormulario({ ...formulario, [name]: value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE}/api/salas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formulario),
      });

      if (!res.ok) {
        let msg = 'Error al registrar sala';
        try {
          const data = await res.json();
          if (data?.mensaje) msg = data.mensaje;
        } catch {}
        alert(msg);
        return;
      }

      try { await res.json(); } catch {}

      alert('Sala registrada correctamente');
      setFormulario({ colegio_id: '', nombre: '', tipo: 'Informática' });
      window.location.reload();
    } catch (e) {
      console.error('Error registrando sala:', e);
      alert('No se pudo registrar la sala.');
    }
  };

  // ====== Helpers ======
  const setCampo = (campo, valor) => {
    setDetalle((prev) => ({ ...prev, [campo]: valor }));
  };

  const datetimeLocalToMysql = (dtLocal) => {
    if (!dtLocal) return null;
    const parts = dtLocal.split('T');
    if (parts.length !== 2) return null;
    return `${parts[0]} ${parts[1]}:00`;
  };

  const mysqlToDatetimeLocal = (dtMysql) => {
    if (!dtMysql) return '';
    if (typeof dtMysql === 'string' && dtMysql.includes(' ')) {
      const [d, t] = dtMysql.split(' ');
      return `${d}T${t.slice(0, 5)}`;
    }
    return '';
  };

  // ====== Modal: abrir/cerrar/cargar/guardar ======
  const abrirModalDetalle = async (sala) => {
    setSalaActual(sala);
    setModalAbierto(true);
    setCargandoDetalle(true);

    // Reset
    setDetalle({
      tiene_impresora: 0,
      impresora_marca: '',
      impresora_modelo: '',
      impresora_tiene_cable_usb: 0,

      tiene_proyector: 0,
      proyector_marca: '',
      proyector_modelo: '',
      proyector_cable_tipo: 'NINGUNO',

      tiene_televisor: 0,
      televisor_marca: '',
      televisor_pulgadas: '',
      televisor_cable_tipo: 'NINGUNO',
      televisor_tiene_control: 0,

      observacion: '',
      fecha_verificacion: ''
    });

    try {
      const res = await fetch(`${API_BASE}/api/salas/${sala.id}/detalle`);
      const data = res.ok ? await res.json() : null;

      if (data) {
        setDetalle({
          tiene_impresora: data.tiene_impresora ? 1 : 0,
          impresora_marca: data.impresora_marca || '',
          impresora_modelo: data.impresora_modelo || '',
          impresora_tiene_cable_usb: data.impresora_tiene_cable_usb ? 1 : 0,

          tiene_proyector: data.tiene_proyector ? 1 : 0,
          proyector_marca: data.proyector_marca || '',
          proyector_modelo: data.proyector_modelo || '',
          proyector_cable_tipo: data.proyector_cable_tipo || 'NINGUNO',

          tiene_televisor: data.tiene_televisor ? 1 : 0,
          televisor_marca: data.televisor_marca || '',
          televisor_pulgadas: data.televisor_pulgadas ?? '',
          televisor_cable_tipo: data.televisor_cable_tipo || 'NINGUNO',
          televisor_tiene_control: data.televisor_tiene_control ? 1 : 0,

          observacion: data.observacion || '',
          fecha_verificacion: mysqlToDatetimeLocal(data.fecha_verificacion)
        });
      }
    } catch (e) {
      console.error('Error al cargar detalle de sala:', e);
      alert('No se pudo cargar el detalle de la sala.');
    } finally {
      setCargandoDetalle(false);
    }
  };

  const cerrarModal = () => {
    if (guardandoDetalle) return;
    setModalAbierto(false);
    setSalaActual(null);
  };

  const guardarDetalle = async () => {
    if (!salaActual) return;

    setGuardandoDetalle(true);

    const payload = {
      // Impresora
      tiene_impresora: Number(detalle.tiene_impresora) || 0,
      impresora_marca: Number(detalle.tiene_impresora) === 1 ? (detalle.impresora_marca || null) : null,
      impresora_modelo: Number(detalle.tiene_impresora) === 1 ? (detalle.impresora_modelo || null) : null,
      impresora_tiene_cable_usb: Number(detalle.tiene_impresora) === 1 ? (Number(detalle.impresora_tiene_cable_usb) || 0) : 0,

      // Proyector
      tiene_proyector: Number(detalle.tiene_proyector) || 0,
      proyector_marca: Number(detalle.tiene_proyector) === 1 ? (detalle.proyector_marca || null) : null,
      proyector_modelo: Number(detalle.tiene_proyector) === 1 ? (detalle.proyector_modelo || null) : null,
      proyector_cable_tipo:
        Number(detalle.tiene_proyector) === 1
          ? (detalle.proyector_cable_tipo || 'NINGUNO')
          : 'NINGUNO',

      // Televisor
      tiene_televisor: Number(detalle.tiene_televisor) || 0,
      televisor_marca: Number(detalle.tiene_televisor) === 1 ? (detalle.televisor_marca || null) : null,
      televisor_pulgadas:
        Number(detalle.tiene_televisor) === 1
          ? (detalle.televisor_pulgadas === '' ? null : Number(detalle.televisor_pulgadas))
          : null,
      televisor_cable_tipo:
        Number(detalle.tiene_televisor) === 1
          ? (detalle.televisor_cable_tipo || 'NINGUNO')
          : 'NINGUNO',
      televisor_tiene_control:
        Number(detalle.tiene_televisor) === 1
          ? (Number(detalle.televisor_tiene_control) || 0)
          : 0,

      observacion: detalle.observacion || null,
      fecha_verificacion: datetimeLocalToMysql(detalle.fecha_verificacion)
    };

    try {
      const res = await fetch(`${API_BASE}/api/salas/${salaActual.id}/detalle`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        console.error('Error guardando detalle:', data);
        alert(data?.mensaje || 'Error al guardar el detalle.');
        return;
      }

      alert(data?.mensaje || 'Detalle de sala guardado.');
      cerrarModal();
    } catch (e) {
      console.error('Error guardando detalle:', e);
      alert('No se pudo guardar el detalle.');
    } finally {
      setGuardandoDetalle(false);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-blue-700">Gestión de Salas</h2>

      <form onSubmit={enviarFormulario} className="space-y-3 mb-6 bg-white p-4 rounded-lg shadow">
        <select
          name="colegio_id"
          value={formulario.colegio_id}
          onChange={manejarCambio}
          required
          className="w-full border px-3 py-2 rounded"
        >
          <option value="">-- Seleccionar colegio --</option>
          {colegios.map((c) => (
            <option key={c.id} value={c.id}>{c.nombre}</option>
          ))}
        </select>

        <input
          name="nombre"
          placeholder="Nombre de sala"
          value={formulario.nombre}
          onChange={manejarCambio}
          required
          className="w-full border px-3 py-2 rounded"
        />

        <select
          name="tipo"
          value={formulario.tipo}
          onChange={manejarCambio}
          className="w-full border px-3 py-2 rounded"
        >
          <option value="Informática">Informática</option>
          <option value="Robótica">Robótica</option>
          <option value="Otra">Otra</option>
        </select>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Registrar Sala
        </button>
      </form>

      <h3 className="text-lg font-semibold mb-2 text-gray-800">Listado de salas</h3>
      <table className="w-full table-auto border-collapse bg-white shadow rounded-lg">
        <thead>
          <tr className="bg-blue-100 text-blue-900">
            <th className="px-4 py-2 border">Colegio</th>
            <th className="px-4 py-2 border">Nombre</th>
            <th className="px-4 py-2 border">Tipo</th>
            <th className="px-4 py-2 border">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {salas.map((s, i) => (
            <tr key={i} className="text-center hover:bg-blue-50">
              <td className="px-4 py-2 border">{s.colegio}</td>
              <td className="px-4 py-2 border">{s.nombre}</td>
              <td className="px-4 py-2 border">{s.tipo}</td>
              <td className="px-4 py-2 border">
                <button
                  onClick={() => abrirModalDetalle(s)}
                  title="Detalle de sala"
                  className="px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                >
                  🧾
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ====== MODAL DETALLE SALA (SIN BLOQUEAR SCROLL PRINCIPAL) ====== */}
      {modalAbierto && (
        <>
          <div className="fixed inset-0 z-40 bg-black bg-opacity-40 pointer-events-none" />
          <div className="fixed inset-0 z-50 pointer-events-none">
            <div className="min-h-screen w-full flex items-center justify-center p-4">
              <div className="w-full max-w-3xl pointer-events-auto bg-white rounded-xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white">
                  <div>
                    <h3 className="text-lg font-bold">Detalle de sala</h3>
                    <p className="text-sm opacity-90">
                      {salaActual?.colegio} — <span className="font-semibold">{salaActual?.nombre}</span>
                    </p>
                  </div>
                  <button
                    onClick={cerrarModal}
                    className="bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-1 rounded"
                    title="Cerrar"
                  >
                    ✕
                  </button>
                </div>

                {/* Body con scroll propio */}
                <div className="flex-1 overflow-y-auto p-5">
                  {cargandoDetalle ? (
                    <div className="text-center py-10 text-gray-600">Cargando detalle...</div>
                  ) : (
                    <div className="space-y-6">
                      {/* ... (el resto de tu UI del modal queda igual) ... */}
                      {/* NO toqué nada del contenido, solo las URLs del backend */}
                      {/* (Todo lo que sigue es idéntico a tu código original) */}

                      {/* IMPRESORA */}
                      <div className="bg-gray-50 border rounded-lg p-4">
                        <h4 className="font-semibold text-gray-800 mb-3">Impresora</h4>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">¿Cuenta con impresora?</label>
                            <select
                              value={detalle.tiene_impresora}
                              onChange={(e) => {
                                const val = Number(e.target.value);
                                setCampo('tiene_impresora', val);
                                if (val === 0) {
                                  setCampo('impresora_marca', '');
                                  setCampo('impresora_modelo', '');
                                  setCampo('impresora_tiene_cable_usb', 0);
                                }
                              }}
                              className="w-full border px-3 py-2 rounded"
                            >
                              <option value={0}>No</option>
                              <option value={1}>Sí</option>
                            </select>
                          </div>

                          {Number(detalle.tiene_impresora) === 1 && (
                            <>
                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Marca</label>
                                <input
                                  value={detalle.impresora_marca}
                                  onChange={(e) => setCampo('impresora_marca', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                  placeholder="Ej: HP"
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Modelo</label>
                                <input
                                  value={detalle.impresora_modelo}
                                  onChange={(e) => setCampo('impresora_modelo', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                  placeholder="Ej: LaserJet 107a"
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">¿Tiene cable USB?</label>
                                <select
                                  value={detalle.impresora_tiene_cable_usb}
                                  onChange={(e) => setCampo('impresora_tiene_cable_usb', Number(e.target.value))}
                                  className="w-full border px-3 py-2 rounded"
                                >
                                  <option value={0}>No</option>
                                  <option value={1}>Sí</option>
                                </select>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      {/* PROYECTOR */}
                      <div className="bg-gray-50 border rounded-lg p-4">
                        <h4 className="font-semibold text-gray-800 mb-3">Proyector</h4>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">¿Cuenta con proyector?</label>
                            <select
                              value={detalle.tiene_proyector}
                              onChange={(e) => {
                                const val = Number(e.target.value);
                                setCampo('tiene_proyector', val);
                                if (val === 0) {
                                  setCampo('proyector_marca', '');
                                  setCampo('proyector_modelo', '');
                                  setCampo('proyector_cable_tipo', 'NINGUNO');
                                }
                              }}
                              className="w-full border px-3 py-2 rounded"
                            >
                              <option value={0}>No</option>
                              <option value={1}>Sí</option>
                            </select>
                          </div>

                          {Number(detalle.tiene_proyector) === 1 && (
                            <>
                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Marca</label>
                                <input
                                  value={detalle.proyector_marca}
                                  onChange={(e) => setCampo('proyector_marca', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                  placeholder="Ej: Epson"
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Modelo</label>
                                <input
                                  value={detalle.proyector_modelo}
                                  onChange={(e) => setCampo('proyector_modelo', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                  placeholder="Ej: PowerLite X41"
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Tipo de cable de video</label>
                                <select
                                  value={detalle.proyector_cable_tipo}
                                  onChange={(e) => setCampo('proyector_cable_tipo', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                >
                                  <option value="NINGUNO">Ninguno</option>
                                  <option value="VGA">VGA</option>
                                  <option value="HDMI">HDMI</option>
                                </select>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      {/* TELEVISOR */}
                      <div className="bg-gray-50 border rounded-lg p-4">
                        <h4 className="font-semibold text-gray-800 mb-3">Televisor</h4>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">¿Cuenta con televisor?</label>
                            <select
                              value={detalle.tiene_televisor}
                              onChange={(e) => {
                                const val = Number(e.target.value);
                                setCampo('tiene_televisor', val);
                                if (val === 0) {
                                  setCampo('televisor_marca', '');
                                  setCampo('televisor_pulgadas', '');
                                  setCampo('televisor_cable_tipo', 'NINGUNO');
                                  setCampo('televisor_tiene_control', 0);
                                }
                              }}
                              className="w-full border px-3 py-2 rounded"
                            >
                              <option value={0}>No</option>
                              <option value={1}>Sí</option>
                            </select>
                          </div>

                          {Number(detalle.tiene_televisor) === 1 && (
                            <>
                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Marca</label>
                                <input
                                  value={detalle.televisor_marca}
                                  onChange={(e) => setCampo('televisor_marca', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                  placeholder="Ej: LG"
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Pulgadas</label>
                                <input
                                  type="number"
                                  min="0"
                                  value={detalle.televisor_pulgadas}
                                  onChange={(e) => setCampo('televisor_pulgadas', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                  placeholder="Ej: 43"
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">Tipo de cable de video</label>
                                <select
                                  value={detalle.televisor_cable_tipo}
                                  onChange={(e) => setCampo('televisor_cable_tipo', e.target.value)}
                                  className="w-full border px-3 py-2 rounded"
                                >
                                  <option value="NINGUNO">Ninguno</option>
                                  <option value="VGA">VGA</option>
                                  <option value="HDMI">HDMI</option>
                                </select>
                              </div>

                              <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">¿Cuenta con control?</label>
                                <select
                                  value={detalle.televisor_tiene_control}
                                  onChange={(e) => setCampo('televisor_tiene_control', Number(e.target.value))}
                                  className="w-full border px-3 py-2 rounded"
                                >
                                  <option value={0}>No</option>
                                  <option value={1}>Sí</option>
                                </select>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      {/* OBSERVACIÓN + FECHA */}
                      <div className="bg-white border rounded-lg p-4">
                        <div className="grid grid-cols-1 gap-4">
                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Observación</label>
                            <textarea
                              value={detalle.observacion}
                              onChange={(e) => setCampo('observacion', e.target.value)}
                              className="w-full border px-3 py-2 rounded"
                              rows={3}
                              placeholder="Ej: proyector sin cable, televisor sin control, etc."
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Fecha de verificación</label>
                            <input
                              type="datetime-local"
                              value={detalle.fecha_verificacion}
                              onChange={(e) => setCampo('fecha_verificacion', e.target.value)}
                              className="w-full border px-3 py-2 rounded"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Footer fijo */}
                <div className="border-t bg-white px-5 py-4 flex items-center justify-end gap-2">
                  <button
                    onClick={cerrarModal}
                    disabled={guardandoDetalle}
                    className="px-4 py-2 rounded border hover:bg-gray-50"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={guardarDetalle}
                    disabled={guardandoDetalle}
                    className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                  >
                    {guardandoDetalle ? 'Guardando...' : 'Guardar detalle'}
                  </button>
                </div>

              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GestionSalas;